import { gql } from '@apollo/client';

import { ChannelMetadata } from './types';

export const USE_CHANNELS_HOOK_QUERY = gql`
  query ChannelsQuery {
    messageChannels {
      name
      id
      messageMedium
      channelType
    }
  }
`;

export const DEFAULT_CHANNELS: ChannelMetadata[] = [];
